import React, { useEffect } from 'react'
import { useAppSelector } from '@/store'

const ThemeManager: React.FC = () => {
    const mode = useAppSelector((state) => state.theme.mode)

    useEffect(() => {
        const root = document.documentElement
        if (mode === 'dark') {
            root.classList.add('dark')
        } else {
            root.classList.remove('dark')
        }
    }, [mode])

    return null
}

export default ThemeManager